import React from "react";
import { Box, Image, Container } from "@chakra-ui/react";
import TitleSpoleto from "../Title";
import SubTitle from "../SubTitle";

const Steps = () => {
  return (
    <Box id="etapas" bg="#E5E5E5" py={12} pb="16">
      <Container maxW="container.xl">
        <TitleSpoleto color="#5B3923">Etapas</TitleSpoleto>
        <SubTitle color="#5B3923">Entenda as fases e datas.</SubTitle>
        <Box w="100%" marginTop={[10, null, 16]}>
          <Image
            d={["none", null, "block"]}
            w="100%"
            src="assets/images/area-etapas-desktop.png"
          />
          <Image
            d={["block", null, "none"]}
            mx="auto"
            w="45%"
            src="assets/images/area-etapas-mobile.png"
          />
        </Box>
      </Container>
    </Box>
  );
};

export default Steps;
